import { ReactNode } from 'react';
import { Heading, Private } from '@core/ui';
import { useTranslation } from 'react-i18next';

interface Props {
    children: ReactNode;
    isInactive: boolean;
    isVisible: number;
}

export const ListWebinarCardHeader = ({ children, isInactive, isVisible }: Props) => {
    const { t } = useTranslation();

    return (
        <header>
            <Heading variant="h3" classNames={`${isInactive && 'text-gray-400'}`}>
                {children}
            </Heading>
            {!isVisible && (
                <span className="private">
                    <Private />
                    {t('Webinar.Visibility.Private')}
                </span>
            )}
        </header>
    )
};